import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/api/client";
import { Section, Badge, Empty } from "@/components/ui/kit";
import { fmtINR, fmtDate } from "@/utils/format";

export default function MyContributions() {
  const [rows, setRows] = useState([]);
  const [donorId, setDonorId] = useState(null);

  useEffect(() => {
    api.get("/donors/me").then(async (r) => {
      const id = r.data.data.donorId;
      setDonorId(id);
      const l = await api.get("/donations", { params: { donorId: id, size: 100 } });
      setRows(l.data.data.content);
    });
  }, []);

  return (
    <div className="space-y-6" data-testid="my-contributions-page">
      <Section title="My Contributions" kicker="Every gift, every receipt" />
      <div className="rounded-xl border border-emerald-900/10 bg-white p-4 overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[11px] uppercase tracking-widest text-emerald-800/70 border-b border-emerald-900/10">
              <th className="py-2 pr-4">Date</th>
              <th className="py-2 pr-4">Purpose</th>
              <th className="py-2 pr-4">Amount</th>
              <th className="py-2 pr-4">Mode</th>
              <th className="py-2 pr-4">Type</th>
              <th className="py-2 pr-4">Receipt</th>
              <th className="py-2 pr-4"></th>
            </tr>
          </thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.donationId} data-testid={`contribution-row-${r.donationId}`} className="border-b border-emerald-900/5 hover:bg-emerald-50/40">
                <td className="py-3 pr-4 text-muted-foreground">{fmtDate(r.donationDate)}</td>
                <td className="py-3 pr-4 font-semibold text-emerald-950">{r.purposeName}</td>
                <td className="py-3 pr-4 mono font-semibold text-emerald-900">{fmtINR(r.amount)}</td>
                <td className="py-3 pr-4 mono text-xs">{r.paymentMode}</td>
                <td className="py-3 pr-4">
                  {r.donationType === "MATCHED" ? <Badge tone="warm">Matched</Badge> : <Badge tone="brand">Self</Badge>}
                </td>
                <td className="py-3 pr-4 mono text-xs text-muted-foreground">{r.receiptNumber || "—"}</td>
                <td className="py-3 pr-4">
                  <Link to={`/donor/contributions/${r.donationId}`} data-testid={`view-detail-${r.donationId}`} className="text-emerald-800 text-xs font-semibold hover:underline">View journey →</Link>
                </td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={7}><Empty title="No contributions yet" testid="my-contributions-empty" /></td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
